import { formatDate, formatTime } from "../../lib/dateTime";

/**
 * Times on the gateway console, in the OPERATOR's language. Every one of them used to be
 * formatted in the browser's locale (`toLocaleTimeString([])`), so a French page carried an
 * English 12-hour clock ("au 08:14 PM"). The clock now comes from lib/dateTime, the one stamp
 * formatter of the Super Admin; a row's own timestamp uses its `formatDateTime`.
 */

/**
 * When a resource was read: the time alone when the read is from today, date and time
 * otherwise. With no polling, a tab left open overnight would otherwise show "as of 14:02"
 * for yesterday's money. `now` is injectable for tests.
 */
export function freshnessStamp(at, lang, now = new Date()) {
  const time = formatTime(at, lang);
  return at.toDateString() === now.toDateString() ? time : `${formatDate(at, lang)} ${time}`;
}
